// src/routes/RouteErrorBoundary.js
import React from 'react';

/** Classic React Error Boundary for route elements */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    // Optional: send to telemetry/logging
    // console.error('Route error:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 16 }}>
          <h3>Something went wrong loading this page.</h3>
          <p style={{ color: '#666', marginTop: 8 }}>
            Try refreshing, or go back and try again.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

/** Convenience wrapper to use in routes */
export default function RouteErrorBoundary({ children }) {
  return <ErrorBoundary>{children}</ErrorBoundary>;
}
